import './App.scss';
import './Contexts/ToastContext.scss';
import { Route, Routes, Navigate } from 'react-router-dom';
import Layout from './Layout/Layout';
import { Home } from './Home/Home';
import { Products } from './Products/Products';
import { ProductsMobNew } from './Products/Mobile/ProductsMobNew';
import { ProductsMobTouchExperiment } from './Products/Mobile/ProductsMobTouchExperiment';
import { MobProductsScrollSnapPage } from './Products/Mobile/MobProductsScrollSnapPage';
import { MobProductsWebComponentsPage } from './Products/Mobile/MobProductsWebComponentsPage';
import { MobProductsReducerPrefetchPage } from './Products/Mobile/MobProductsReducerPrefetchPage';
import { MobLtrCarouselPreviewPage } from './Products/Mobile/MobLtrCarouselPreviewPage';
import { Slider } from './Slider/Slider';
import { Filter } from './Filter/Filter';
import { MobSpecific } from './Specific/Mobile/Specific';
import { MobWishlist } from './Wishlist/Mob/Wishlist';
import { MobCart } from './Cart/Mob/Cart';
import { CartDesignOptions } from './Cart/Mob/CartDesignOptions';
import { MobAddress } from './Address/Mob/Address';
// import { MobMyProfileEdit } from './MyProfile/Edit/Mob/MyProfileEdit';
import { MobOrders } from './Orders/Mob/Orders';
import { MobFeedback } from './Orders/Mob/Feedback';
import { MobMyProfile } from './MyProfile/Mob/MyProfile';
import { MobLogin } from './Auth/Login/Mob/Login';
import { MobRegister } from './Auth/Register/Mob/Register';
import { MobFullReviews } from './FullReview/Mob/FullReviews';
import { isMobile } from 'react-device-detect';
import { Specific } from './Specific/Specific';
import { Wishlist } from './Wishlist/Wishlist';
import { Cart } from './Cart/Cart';
import { AddAddress } from './Address/Address';
import { FullReviews } from './FullReview/FullReviews';
import { FullReviewDesignOptions } from './FullReview/FullReviewDesignOptions';
import { ProductDetailsDesignProposals } from './Specific/ProductDetailsDesignProposals';
import { Orders } from './Orders/Orders';
import { OrderSummary } from './OrderSummary/OrderSummary';
import { OrderSuccess } from './OrderSuccess/OrderSuccess';
import { MyProfile } from './MyProfile/MyProfile';
// import { MyProfileEdit } from './MyProfile/Edit/MyProfileEdit';
import { Login } from './Auth/Login/Login';
import { Register } from './Auth/Register/Register';
import { Verify } from './Auth/Register/Verify';
import { SetPassword } from './Auth/SetPassword/SetPassword';
import PasswordSetupGuard from './Components/middleware/PasswordSetupGuard';
import { ApiProvider } from './ApiContext';
import { ProfileProvider } from './Contexts/ProfileContext';
import { ToastProvider } from './Contexts/ToastContext';
import { ThemeProvider } from './Contexts/ThemeContext';
import ProtectedRoute from './Components/middleware/ProtectedRoute';
import { CheckoutLayout } from './Checkout/CheckoutLayout';

import { MobMyProfileHybrid } from './MyProfile/Mob/MyProfile-hybrid.jsx';
import { MobCoupons } from './Account/Mob/MobCoupons';
import { MobMyCredits } from './Account/Mob/MobMyCredits';
import { MobVip } from './Account/Mob/MobVip';
import { Coupons } from './Account/Web/Coupons';
import { MyCredits } from './Account/Web/MyCredits';
import { Vip } from './Account/Web/Vip';
import { IconSetTest } from './IconSetTest/IconSetTest';
import { MenuTransitionTest } from './Layout/NavBar/MenuTransitionTest';
import { OrderStatusDesignShowcase } from './Orders/Mob/OrderStatusDesignShowcase';
import { SiteDesignDirectionsPage } from './Design/SiteDesignDirectionsPage';
import { ToastDesignShowcaseMob } from './Toast/ToastDesignShowcaseMob.jsx';
import { GoogleOAuthProviderWrapper } from './Auth/GoogleSignInButton';
import { LegalPage } from './Legal/LegalPage';
import { useParams } from 'react-router-dom';

function VerifyRedirect() {
  const { phone } = useParams();
  return <Navigate to={`/auth/verify/phone/${phone}`} replace />;
}

function App() {
  return (
    <div className="App">

      {/* < Home /> */}
      <div>
        <GoogleOAuthProviderWrapper>
        <ApiProvider>
          <ThemeProvider>
            <ProfileProvider>
              <ToastProvider>
              <PasswordSetupGuard>
              <Layout>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route
                exact
                path="/products/:category/:subcategory"
                element={isMobile ? <ProductsMobNew /> : <Products />}
              />
              <Route exact path="/slider" element={<Slider />} />
              {/* Temporary route for viewing cart design options */}
              <Route exact path="/cart-design-options" element={<CartDesignOptions />} />
              {/* Order status design showcase */}
              <Route exact path="/order-status-showcase" element={<OrderStatusDesignShowcase />} />
              <Route exact path="/site-design-directions" element={<SiteDesignDirectionsPage />} />
              <Route exact path="/search-header-design-directions" element={<SiteDesignDirectionsPage />} />
              {/* Toast design showcase (mobile only) */}
              {isMobile && <Route exact path="/toast-design-showcase" element={<ToastDesignShowcaseMob />} />}
              <Route exact path="/specific/:product_id" element={isMobile ? <MobSpecific /> : <Specific />} />
              <Route element={<ProtectedRoute />}>
                {/* Checkout flow with persistent ItemsProgress */}
                <Route element={<CheckoutLayout />}>
                  {
                    isMobile ?
                      <Route exact path="/cart" element={<MobCart />} />
                      :
                      <Route exact path="/cart" element={<Cart />} />
                  }
                  {
                    isMobile ?
                      <Route exact path="/add-address" element={<MobAddress />} />
                      :
                      <Route exact path="/add-address" element={<AddAddress />} />
                  }
                  {
                    isMobile ?
                      <Route exact path="/order-summary" element={<OrderSummary />} />
                      :
                      <Route exact path="/order-summary" element={<OrderSummary />} />
                  }
                  <Route exact path="/order-success" element={<OrderSuccess />} />
                </Route>
                {
                  isMobile ?
                    <Route exact path="/orders" element={<MobOrders />} />
                    :
                    <Route exact path="/orders" element={<Orders />} />
                }
                <Route exact path="/orders/feedback" element={<MobFeedback />} />

                {
                  isMobile ?
                    <Route exact path="/profile" element={<MobMyProfileHybrid />} />
                    :
                    <Route exact path="/profile" element={<MyProfile />} />
                }

                {/* Removed separate edit routes - profile is now editable inline */}
                {/* {
                  isMobile ?
                    <Route exact path="/profile/edit" element={<MobMyProfileEdit />} />
                    :
                    <Route exact path="/profile/edit" element={<MyProfileEdit />} />
                } */}

                {
                  isMobile ?
                    <Route exact path="/wishlist" element={<MobWishlist />} />
                    :
                    <Route exact path="/wishlist" element={<Wishlist />} />
                }
                {
                  isMobile ?
                    <Route exact path="/coupons" element={<MobCoupons />} />
                    :
                    <Route exact path="/coupons" element={<Coupons />} />
                }
                {
                  isMobile ?
                    <Route exact path="/my-credits" element={<MobMyCredits />} />
                    :
                    <Route exact path="/my-credits" element={<MyCredits />} />
                }
                {
                  isMobile ?
                    <Route exact path="/vip" element={<MobVip />} />
                    :
                    <Route exact path="/vip" element={<Vip />} />
                }
              </Route>
              {
                isMobile ?
                  <Route exact path="/auth/login" element={<MobLogin />} />
                  :
                  <Route exact path="/auth/login" element={<Login />} />
              }
              {
                isMobile ?
                  <Route exact path="/auth/register" element={<MobRegister />} />
                  :
                  <Route exact path="/auth/register" element={<Register />} />
              }

              <Route exact path="/auth/verify/:type/:identifier" element={<Verify />} />
              {/* Backward compat: /auth/verify/:phone -> /auth/verify/phone/:phone */}
              <Route exact path="/auth/verify/:phone" element={<VerifyRedirect />} />
              <Route exact path="/auth/set-password" element={<SetPassword />} />

              {
                isMobile ?
                  <>
                    <Route exact path="/full-review" element={<MobFullReviews />} />
                    <Route exact path="/full-review/:product_id" element={<MobFullReviews />} />
                  </>
                  :
                  <Route exact path="/full-review/:product_id" element={<FullReviews />} />
              }


              <Route exact path="/filter" element={<Filter />} />
              <Route exact path="/icon-set-test" element={<IconSetTest />} />
              <Route exact path="/menu-transition-test" element={<MenuTransitionTest />} />
              <Route
                exact
                path="/mob-touch-carousel-experiment"
                element={isMobile ? <ProductsMobTouchExperiment /> : <Navigate to="/" replace />}
              />
              <Route
                exact
                path="/mob-products-approach-scroll-snap"
                element={isMobile ? <MobProductsScrollSnapPage /> : <Navigate to="/" replace />}
              />
              <Route
                exact
                path="/mob-products-approach-web-components"
                element={isMobile ? <MobProductsWebComponentsPage /> : <Navigate to="/" replace />}
              />
              <Route
                exact
                path="/mob-products-approach-reducer-prefetch"
                element={isMobile ? <MobProductsReducerPrefetchPage /> : <Navigate to="/" replace />}
              />
              <Route
                exact
                path="/mob-ltr-carousel-preview"
                element={isMobile ? <MobLtrCarouselPreviewPage /> : <Navigate to="/" replace />}
              />
              <Route exact path="/full-review-design-options" element={<FullReviewDesignOptions />} />
              <Route exact path="/product-details-design-proposals" element={<ProductDetailsDesignProposals />} />

              {/* Legal / Razorpay website policy pages (public) */}
              <Route exact path="/about" element={<LegalPage pageKey="about" />} />
              <Route exact path="/about-us" element={<Navigate to="/about" replace />} />
              <Route exact path="/contact" element={<LegalPage pageKey="contact" />} />
              <Route exact path="/contact-us" element={<Navigate to="/contact" replace />} />
              <Route exact path="/terms" element={<LegalPage pageKey="terms" />} />
              <Route exact path="/termsofuse" element={<Navigate to="/terms" replace />} />
              <Route exact path="/terms-and-conditions" element={<Navigate to="/terms" replace />} />
              <Route exact path="/privacy" element={<LegalPage pageKey="privacy" />} />
              <Route exact path="/privacypolicy" element={<Navigate to="/privacy" replace />} />
              <Route exact path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
              <Route exact path="/refund-policy" element={<LegalPage pageKey="refund" />} />
              <Route exact path="/cancellation-refund-policy" element={<Navigate to="/refund-policy" replace />} />
              <Route exact path="/refunds" element={<Navigate to="/refund-policy" replace />} />
              <Route exact path="/shipping-policy" element={<LegalPage pageKey="shipping" />} />
              <Route exact path="/shipping" element={<Navigate to="/shipping-policy" replace />} />

            </Routes>
          </Layout>
              </PasswordSetupGuard>
              </ToastProvider>
            </ProfileProvider>
          </ThemeProvider>
        </ApiProvider>
        </GoogleOAuthProviderWrapper>
      </div>

    </div>
    
  );
}

export default App;
